module.exports = __webpack_public_path__ + "img/green.0b23526e.webp";